import React, { Component, Fragment } from 'react';
import { connect } from 'redux-scaffolding-ts';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Form } from 'semantic-ui-react';
import { RequestWizardStore, RequestWizardData } from 'stores/requests/create-request-wizard-store';
import { DateInput } from 'widgets/form/dateInput';
import { DateTimeService } from 'services/datetime-service';
import './step4-dates.less';
import { DateWarningType } from 'stores/events/creation-wizard-store';

interface TailwindStepDatesProps extends WithTranslation {
  requestWizardStore?: RequestWizardStore;
  durationWarning: boolean;
}
interface TailwindStepDatesState {
  openDatePopup: boolean;
}

@connect(['requestWizardStore', RequestWizardStore])
class TailwindStepDates extends Component<TailwindStepDatesProps, TailwindStepDatesState> {
  private get requestWizardStore() {
    return this.props.requestWizardStore;
  }

  constructor(props) {
    super(props);
    this.state = { openDatePopup: false };
  }

  private handleValue = (property: string, value: any) => {
    const { startDate, endDate } = this.props.requestWizardStore.state.item;
    const change: Partial<RequestWizardData> = {};
    change[property] = value;

    if (property === 'startDate' || property === 'endDate') {
      const current = DateTimeService.isCoherent(value) ? DateTimeService.toMoment(value) : null;
      const end = DateTimeService.isCoherent(endDate) ? DateTimeService.toMoment(endDate) : null;
      const start = DateTimeService.isCoherent(startDate) ? DateTimeService.toMoment(startDate) : null;

      if (property === 'startDate') {
        if (current && end && current.isAfter(end, 'days')) change.endDate = current ? (current as any) : null;
        this.setState(({ openDatePopup }) => ({ openDatePopup: !openDatePopup }));
      } else {
        if (start && current && start.isAfter(current, 'days')) change.endDate = start ? (start as any) : null;
      }
    }
    this.requestWizardStore.change(change);
  };

  render() {
    const { t, requestWizardStore, durationWarning } = this.props;
    const warnings: DateWarningType[] = [
      ...(durationWarning
        ? ([{ type: 'DURATION', text: this.props.t('There is no default calculated duration for this event') }] as DateWarningType[])
        : [])
    ];
    const { item } = requestWizardStore.state;
    const { startDate, endDate, desiredEventDuration } = item;
    return (
      <>
        <Form>
          <div className="required field mb-3">
            <label className="block text-sm text-gray-700 mb-1">{t('Calculated Duration')}</label>
            <input
              readOnly
              className="w-full p-2 border border-gray-300 rounded"
              id="events__step3__event-duration__input"
              value={`${item?.calculatedEventDuration || ' - '} w/d`}
            />
          </div>

          <div className="required field mb-3">
            <label className="block text-sm text-gray-700 mb-1">{t('Desired Date Slot')}</label>
            <DateInput
              placeholder="From"
              className="w-full p-2 border border-gray-300 rounded"
              value={startDate == null ? '' : DateTimeService.toString(startDate)}
              onChange={(_, value) => this.handleValue('startDate', value)}
            />
            <DateInput
              className="w-full p-2 border border-gray-300 rounded"
              placeholder="To"
              value={endDate == null ? '' : DateTimeService.toString(endDate)}
              onChange={(_, value) => this.handleValue('endDate', value)}
              initialValue={startDate ? DateTimeService.toString(startDate) : null}
              minDate={startDate ? DateTimeService.toString(startDate) : null}
            />
          </div>

          <div className="required field mb-3">
            <label className="block text-sm text-gray-700 mb-1">{t('Desired Event Duration')}</label>
            <div className="flex items-center gap-2">
              <input
                type="number"
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="Request Duration"
                value={desiredEventDuration}
                disabled={false}
                onChange={e => this.handleValue('desiredEventDuration', e.target.value)}
              />
              <span className="whitespace-nowrap">w/d</span>
            </div>
          </div>
        </Form>

        {(warnings || []).length !== 0 && (
          <div className="bg-yellow-50 border border-yellow-300 rounded p-3 mt-4 flex items-start gap-2">
            <svg className="w-5 h-5 text-yellow-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M11.652 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm.348 7v4m0 4h.01"
              />
            </svg>
            <div className="text-yellow-700 text-sm">
              {warnings.map(({ text }, idx) => (
                <p key={`date-warning-${idx}`}>{text}</p>
              ))}
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withTranslation()(TailwindStepDates);
